import { IRootState } from '../../../store'
import { ISearchState } from '../store/search.types'

export const getSearchStateSelector = (state: IRootState): ISearchState => state.search
